import { observer } from 'mobx-react';
import cls from 'classnames';

import Button, { TRANSPARENT } from '@/common/components/Button/Button';
import Icon from '@/common/components/Icon/Icon';
import { useForwardShareStore } from '@/forwarding/components/ForwardModal/ForwardShareStore';
import { ShareActionType } from '@/forwarding/constants/ShareActionType';
import { getShareActionIcon } from '@/forwarding/utils/getShareActionIcon';
import { getShareActionTitle } from '@/forwarding/utils/getShareActionTitle';

import styles from './ShareActions.module.css';

export interface ShareActionsProps {
  className?: string;
  onSelect: (action: ShareActionType) => void;
}

function ShareActions(props: ShareActionsProps) {
  const { className, onSelect } = props;
  const { actions, hasMultipleUrls } = useForwardShareStore();

  return (
    <div className={cls(styles.actions, className)}>
      {actions.map((action) => (
        <Button
          key={action}
          color={TRANSPARENT}
          className={styles.action}
          aria-label={getShareActionTitle(action, hasMultipleUrls)}
          onClick={() => onSelect(action)}
          iconPosition="left"
        >
          <Icon name={getShareActionIcon(action)} className={styles.actionIcon} />

          {getShareActionTitle(action, hasMultipleUrls)}
        </Button>
      ))}
    </div>
  );
}

export default observer(ShareActions);
